/**
 * Shared helpers for converting between archlang's SourceSpan shape and
 * LSP's Range shape. Kept in one place so every provider uses the same
 * (line-0 vs line-1) convention.
 *
 * archlang internal: 1-based line, 1-based column.
 * LSP over the wire: 0-based line, 0-based character.
 */

import type { Range, Position as LspPosition } from "vscode-languageserver";
import type { SourceSpan } from "@archlang/engine";

export function toLspRange(span: SourceSpan): Range {
  return {
    start: toLspPosition(span.start),
    end: toLspPosition(span.end),
  };
}

export function toLspPosition(pos: {
  line: number;
  column: number;
}): LspPosition {
  return {
    line: Math.max(0, pos.line - 1),
    character: Math.max(0, pos.column - 1),
  };
}
